/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, total: NonNullable<unknown> }} Partner_Org_Contract_Seats_OfInputs */



/**
* | output |
* | --- |
* | "{used} of {total}" |
*
* @param {Partner_Org_Contract_Seats_OfInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_seats_of = /** @type {((inputs: Partner_Org_Contract_Seats_OfInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Seats_OfInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.used} von ${i?.total}`)
	return /** @type {LocalizedString} */ (`${i?.used} of ${i?.total}`)
});